module.exports = __webpack_public_path__ + "static/media/chess-pawn-alt.6926aa5a.svg";